export default __webpack_public_path__ + "static/media/143.9710c691.jpg";